module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-person-fill-1fa82d2e.svg";